import React from 'react';

import loadable from '@loadable/component';

const SortableTable = (props) => {
  const Component = loadable(() => import('./SortableTable.js'), { ssr: false });
  return <Component {...props} />;
};

export default SortableTable;
